import { all } from "redux-saga/effects";
import {
  getSagaProductsList,
  createSagaProducts,
  updateSagaProduct,
  getSagaProductsById,
  duplicateSagaProduct,
  getSagaCabanaList,
  getSagaProductFiles,
  deleteSagaProductFile,
} from "./sagaProducts";
import {
  getSagaBookingList,
  getSagaBooking,
  addSagaBookingNote,
  updateSagaBookingNote,
  deleteSagaBookingNote,
  getNotesTasksCountSagaBooking,
  getPendingConfirmationCountSagaBooking,
  getSagaBookingNotesList,
  getSagaBookingNote,
  addSagaBookingLog,
  updateSagaBookingLog,
  deleteSagaBookingLog,
  getSagaBookingLogsList,
  getSagaBookingLog,
  getSagaBookingMetas,
  cancelSagaBooking,
  acceptSagaBooking,
  refundSagaBooking,
  resendConfirmationSagaBooking,
  updateSagaBooking,
  resetSagaListBooking,
  processPaymentSagaBooking,
  addSagaBooking,
  postSagaAvailabilitys,
  requestPaymentSagaBooking,
} from "./sagaBooking";
import {
  getSagaAccountList,
  getSagaAccountListFiltered,
  getSagaAccount,
  resetSagaAccount,
  createSagaAccount,
  editSagaAccount,
  editSagaAccountAddress,
  getSagaAccountBank,
  editSagaAccountBank,
  getSagaAccountImages,
  createSagaAccountImage,
  editSagaAccountImage,
  deleteSagaAccountImage,
  createSagaAccountImages,
  deleteSagaAccountImages,
  getSagaAccountUsers,
  addSagaAccountUsers,
  deleteSagaAccountUser,
  createSagaAccountAddress,
  createSagaAccountBank,
  // editSagaAccountProperties,
} from "./sagaAccount";

import {
  getSagaAccountPropertiesList,
  getAccountProperties,
  addAccountProperties,
  editAccountProperties,
  editAccountPropertiesList,
  deleteAccountPropertiesSaga,
  importAccountProperties,
  importAccountPropertiesImages,
  resumeImportImagesJob,
} from "./sagaAccountProperties";

import {
  getSagaCouponList,
  getSagaCoupon,
  resetSagaCoupon,
  sagaCreateCoupon,
  sagaUpdateCoupon,
  getCouponCodeDetail,
  updateCouponCodeDetail,
  resetCouponCodeDetail,
} from "./sagaCoupon";
import {
  getSagaUserList,
  getSagaUser,
  getSagaUserByEmail,
  getSagaUserPermissions,
  resetSagaUser,
  updateSagaUser,
  sagaCreateUser,
  updateSagaPassword,
} from "./sagaUsers";
import {
  addSagaExtra,
  addSagaExtraProduct,
  addSagaExtrasProduct,
  deleteSagaExtrasProduct,
  deleteSagaExtra,
  deleteSagaExtraProducts,
  getSagaExtra,
  getSagaExtraList,
  getSagaExtraProducts,
  getSagaProductExtra,
  resetSagaExtra,
  updateSagaExtra,
  addSagaExtraTaxes,
  deleteSagaExtraTaxes,
} from "./sagaExtras";
import {
  getSagaProductCategoryList,
  getSagaProductCategory,
  addSagaProductCategory,
  deleteSagaProductCategory,
  editSagaProductCategory,
} from "./sagaProductCategories";
import {
  getSagaInclusionsCategoryList,
  getSagaProductInclusionsCategoryList,
  createSagaInclusionsCategory,
  updateSagaProductInclusionsCategory,
  deleteSagaProductInclusionsCategory,
} from "./sagaInclusionsCategories";
import {
  getSagaExclusionsCategoryList,
  createSagaProductExclusionsCategory,
  getSagaProductExclusionsCategoryList,
  updateSagaProductExclusionsCategory,
  deleteSagaProductExclusionsCategory,
} from "./sagaExclusionsCategories";
import {
  getSagaTaxList,
  getSagaTax,
  resetSagaTax,
  addSagaTax,
  addSagaTaxProduct,
  addSagaTaxesProduct,
  deleteSagaTaxesProduct,
  getSagaProductTax,
  getSagaProductTaxList,
  getSagaTaxProducts,
  deleteSagaTax,
  editSagaTax,
  deleteSagaTaxProduct,
  updateSagaTax,
} from "./sagaTax";
import {
  getSagaBlackoutList,
  getSagaBlackout,
  resetSagaBlackout,
  addSagaBlackout,
  updateSagaBlackout,
  deleteSagaBlackout,
  addSagaBlackoutProduct,
  deleteSagaBlackoutProducts,
  getSagaBlackoutProducts,
  getSagaProductBlackout,
  getSagaProductBlackoutList,
} from "./sagaBlackout";
import {
  getSagaWaiverList,
  getSagaWaiver,
  resetSagaWaiver,
  addSagaWaiver,
  updateSagaWaiver,
  deleteSagaWaiver,
  addSagaWaiverProduct,
  addSagaProductWaivers,
  deleteSagaProductWaivers,
  deleteSagaWaiverProducts,
} from "./sagaWaivers";
import {
  getSagaCustomQuestion,
  getSagaCustomQuestionList,
  resetSagaCustomQuestion,
  addSagaCustomQuestion,
  updateSagaCustomQuestion,
  deleteSagaCustomQuestion,
  addSagaCustomQuestionProduct,
  addSagaCustomQuestionsProduct,
  deleteSagaCustomQuestionsProduct,
  deleteSagaCustomQuestionProducts,
} from "./sagaCustomQuestion";
import { createSagaUploadImage } from "./sagaImageUpload";
import { watchProductWorkflow } from "./sagaProductWorkflow";
import {
  getSagaNotificationsEmails,
  createSagaNotificationsEmails,
  updateSagaNotificationsEmails,
  deleteSagaNotificationsEmail,
} from "./sagaNotificationsEmails";
import {
  getSagaGuestDirectoryList,
  getSagaGuestDirectory,
  getSagaGuestDirectoryCategoryList,
  getSagaGuestDirectoryCategory,
  addSagaGuestDirectoryCategory,
  updateSagaGuestDirectoryCategory,
  deleteSagaGuestDirectoryCategory,
  addSagaGuestDirectory,
  updateSagaGuestDirectory,
  deleteSagaGuestDirectory,
  getSagaGuestDirectoryFiles,
  addSagaGuestDirectoryFile,
  updateSagaGuestDirectoryFile,
  deleteSagaGuestDirectoryFile,
  getSagaGuestDirectoryImages,
  addSagaGuestDirectoryImage,
  updateSagaGuestDirectoryImage,
  deleteSagaGuestDirectoryImage,
} from "./sagaGuestDirectory";
import {
  createSagaProductPricing,
  getListSagaProductPricing,
  updateSagaProductPricing,
  deleteSagaProductPricing,
} from "./sagaPricing";
import {
  getSagaParticipantsCategoryList,
  deleteSagaParticipantsCategory,
  updateSagaParticipantsCategory,
  createSagaParticipantsCategory,
  getSagaParticipantTypes,
} from "./sagaParticipansCategories";
import {
  getSagaCurationProductsList,
  getSagaCurationProductId,
  getSagaCurationFeaturedList,
  getSagaCurationFeaturedId,
  addSagaCurationFeaturedActivity,
  updateSagaCurationFeaturedActivity,
  deleteSagaCurationFeaturedActivity,
  getSagaCurationExcludedList,
  getSagaCurationExcludedId,
  addSagaCurationExcludedActivity,
  deleteSagaCurationExcludedActivity,
  addSagaCurationExcludedActivitiesAll,
  deleteSagaCurationExcludedActivitiesAll,
  addSagaCurationFeaturedActivitiesAll,
  deleteSagaCurationFeaturedActivitiesAll,
  updateSagaCurationManagerExclusionActivities,
  getSagaCurationManagerExclusionActivitiesList,
  getSagaCurationManagerActivitiesList,
  getSagaCurationManagerExclusionActivitiesAll,
} from "./sagaCurations";
import {
  getSagaProductAccessibilityList,
  addSagaProductAccessibility,
  getSagaProductAccessibility,
  resetSagaProductAccessibility,
  addSagaAccessibilityProduct,
  updateSagaProductAccessibility,
  deleteSagaAccessibilityProducts,
  deleteSagaProductAccessibility,
  sagaAccessibilityProductsAdd,
  sagaAccessibilityProductsDelete,
} from "./sagaProductAccessibility";
import {
  getSagaHealthSafetyRestriction,
  addSagaHealthSafetyRestriction,
  getSagaHealthSafetyRestrictionsList,
  deleteSagaHealthSafetyRestriction,
  addSagaHealthSafetyRestrictionProduct,
  addSagaProductHealthSafetyRestrictions,
  deleteSagaProductHealthSafetyRestrictions,
  editSagaHealthSafetyRestriction,
  deleteSagaHealthSafetyRestrictionProducts,
} from "./sagaHealthSafetyRestriction";
import {
  getSagaPermissionsList,
  getSagaPermission,
  resetSagaPermission,
  createSagaPermission,
  editSagaPermission,
  deleteSagaPermission,
} from "./sagaPermissions";
import {
  getSagaSubscriptionsList,
  getSagaSubscription,
  resetSagaSubscription,
  createSagaSubscription,
  editSagaSubscription,
  deleteSagaSubscription,
} from "./sagaSubscriptions";
import {
  getSagaAnalyticsHighlights,
  resetSagaAnalyticsHighlights,
} from "./sagaAnalytics";
import {
  addSagaReport,
  addSagaReportTemplate,
  getSagaReportsTemplatesList,
  getSagaReportTemplateId,
  updateSagaReportTemplate,
  deleteSagaReportTemplate,
} from "./sagaReports";
import {
  getSagaMarketingList,
  getSagaMarketing,
  addSagaMarketing,
  updateSagaMarketing,
  deleteSagaMarketing,
} from "./sagaMarketing";

import {
  getSagaCabanaCategoriesList,
  addSagaCabanaCategory,
  resetCabanaCategoryAdd,
  resetListCabanaCategoryList,
  getCabanasCategory,
  editCabanasCategory,
  deleteSagaCabanaCategory,
  addInclusionsExclusionsAccessibility,
  getSagaCabanasUnmappedCount,
} from "./sagaCabanaCategories";
import {
  getDestinationsSgwSaga,
  getDestinationsSgwDetailSaga,
  getDestinationsSaga,
  deleteDestinationSaga,
  addDestinationSaga,
  updateDestinationSaga,
} from "./sagaDestination";

import {
  getNavigationList,
  getNavigation,
  addNavigation,
  editNavigation,
  editNavigationList,
  deleteNavegationSaga,
} from "./sagaNavigation";

import { watchCabanasMapping } from "./sagaCabanasMapping";
import { createSagaPartner, createSagaPaymentProfile, deleteSagaPaymentProfile, getSagaGatewayList, getSagaPartnersList, getSagaPaymentProfileDetails, getSagaPaymentProfileList, initializedSagaProfile, updateSagaPaymentProfile } from "./sagaPayment";
import { getSagaPaymentProfiles, createSagaPaymentRule, getSagaPaymentRules, updateSagaPaymentRule, deleteSagaPaymentRule,resetSagaPaymentRule,resetSagaErrorPaymentRule, getSagaPartnerForAccount } from "./sagaPaymentRule"

export default function* rootSaga() {
  yield all([
    getSagaPaymentProfiles(),
    createSagaPaymentRule(),
    getSagaPaymentRules(),
    updateSagaPaymentRule(),
    deleteSagaPaymentRule(),
    resetSagaPaymentRule(),
    resetSagaErrorPaymentRule(),
    getSagaPartnerForAccount(),
    getSagaProductsList(),
    getSagaProductsById(),
    getSagaBooking(),
    getSagaBookingList(),
    addSagaBookingNote(),
    updateSagaBookingNote(),
    deleteSagaBookingNote(),
    getSagaBookingNotesList(),
    getNotesTasksCountSagaBooking(),
    getPendingConfirmationCountSagaBooking(),
    addSagaBooking(),
    postSagaAvailabilitys(),
    addSagaBookingLog(),
    updateSagaBooking(),
    resetSagaListBooking(),
    updateSagaBookingLog(),
    resendConfirmationSagaBooking(),
    deleteSagaBookingLog(),
    getSagaBookingLogsList(),
    getSagaBookingLog(),
    getSagaBookingMetas(),
    getSagaBookingNote(),
    cancelSagaBooking(),
    acceptSagaBooking(),
    refundSagaBooking(),
    processPaymentSagaBooking(),
    requestPaymentSagaBooking(),
    getSagaAccount(),
    resetSagaAccount(),
    createSagaAccount(),
    editSagaAccount(),
    createSagaAccountAddress(),
    editSagaAccountAddress(),
    getSagaAccountBank(),
    createSagaAccountBank(),
    editSagaAccountBank(),
    getSagaAccountImages(),
    createSagaAccountImage(),
    editSagaAccountImage(),
    deleteSagaAccountImage(),
    createSagaAccountImages(),
    deleteSagaAccountImages(),
    getSagaAccountList(),
    getSagaAccountListFiltered(),
    getSagaAccountUsers(),
    addSagaAccountUsers(),
    deleteSagaAccountUser(),
    getSagaGatewayList(),
    getSagaPartnersList(),
    createSagaPartner(),
    initializedSagaProfile(),
    getSagaPaymentProfileList(),
    getSagaPaymentProfileDetails(),
    createSagaPaymentProfile(),
    updateSagaPaymentProfile(),
    deleteSagaPaymentProfile(),
    // editSagaAccountProperties(),
    getSagaCoupon(),
    getSagaCouponList(),
    resetSagaCoupon(),
    getCouponCodeDetail(),
    updateCouponCodeDetail(),
    resetCouponCodeDetail(),
    sagaCreateCoupon(),
    sagaUpdateCoupon(),
    getSagaUserList(),
    getSagaUserByEmail(),
    getSagaUser(),
    getSagaUserPermissions(),
    resetSagaUser(),
    updateSagaUser(),
    sagaCreateUser(),
    duplicateSagaProduct(),
    getSagaProductCategoryList(),
    getSagaProductCategory(),
    addSagaProductCategory(),
    deleteSagaProductCategory(),
    editSagaProductCategory(),
    getSagaCurationProductsList(),
    getSagaCurationProductId(),
    getSagaCurationManagerExclusionActivitiesAll(),
    getSagaCurationFeaturedList(),
    getSagaCurationFeaturedId(),
    addSagaCurationFeaturedActivity(),
    updateSagaCurationFeaturedActivity(),
    deleteSagaCurationFeaturedActivity(),
    getSagaCurationExcludedList(),
    getSagaCurationExcludedId(),
    addSagaCurationExcludedActivity(),
    deleteSagaCurationExcludedActivity(),
    addSagaCurationExcludedActivitiesAll(),
    deleteSagaCurationExcludedActivitiesAll(),
    addSagaCurationFeaturedActivitiesAll(),
    deleteSagaCurationFeaturedActivitiesAll(),
    updateSagaCurationManagerExclusionActivities(),
    getSagaCurationManagerExclusionActivitiesList(),
    getSagaCurationManagerActivitiesList(),
    createSagaProducts(),
    updateSagaProduct(),
    getSagaProductFiles(),
    deleteSagaProductFile(),
    getSagaTaxList(),
    getSagaProductTaxList(),
    getSagaTax(),
    resetSagaTax(),
    addSagaTax(),
    editSagaTax(),
    deleteSagaTaxProduct(),
    deleteSagaTax(),
    addSagaTaxProduct(),
    addSagaTaxesProduct(),
    deleteSagaTaxesProduct(),
    getSagaProductTax(),
    getSagaTaxProducts(),
    updateSagaTax(),
    getSagaBlackoutList(),
    getSagaProductBlackoutList(),
    getSagaBlackout(),
    resetSagaBlackout(),
    addSagaBlackout(),
    updateSagaBlackout(),
    deleteSagaBlackout(),
    addSagaBlackoutProduct(),
    deleteSagaBlackoutProducts(),
    getSagaBlackoutProducts(),
    getSagaProductBlackout(),
    deleteSagaWaiverProducts(),
    getSagaWaiverList(),
    getSagaWaiver(),
    resetSagaWaiver(),
    addSagaWaiver(),
    addSagaWaiverProduct(),
    addSagaProductWaivers(),
    deleteSagaProductWaivers(),
    updateSagaWaiver(),
    deleteSagaWaiver(),
    createSagaUploadImage(),
    watchProductWorkflow(),
    getSagaInclusionsCategoryList(),
    getSagaProductInclusionsCategoryList(),
    createSagaInclusionsCategory(),
    updateSagaProductInclusionsCategory(),
    deleteSagaProductInclusionsCategory(),
    getSagaExclusionsCategoryList(),
    createSagaProductExclusionsCategory(),
    getSagaProductExclusionsCategoryList(),
    updateSagaProductExclusionsCategory(),
    deleteSagaProductExclusionsCategory(),
    getSagaNotificationsEmails(),
    createSagaNotificationsEmails(),
    updateSagaNotificationsEmails(),
    deleteSagaNotificationsEmail(),
    getSagaGuestDirectoryList(),
    getSagaGuestDirectory(),
    getSagaGuestDirectoryCategoryList(),
    getSagaGuestDirectoryCategory(),
    addSagaGuestDirectoryCategory(),
    updateSagaGuestDirectoryCategory(),
    deleteSagaGuestDirectoryCategory(),
    addSagaGuestDirectory(),
    updateSagaGuestDirectory(),
    deleteSagaGuestDirectory(),
    getSagaGuestDirectoryFiles(),
    addSagaGuestDirectoryFile(),
    updateSagaGuestDirectoryFile(),
    deleteSagaGuestDirectoryFile(),
    getSagaGuestDirectoryImages(),
    addSagaGuestDirectoryImage(),
    updateSagaGuestDirectoryImage(),
    deleteSagaGuestDirectoryImage(),
    createSagaProductPricing(),
    getSagaParticipantsCategoryList(),
    deleteSagaParticipantsCategory(),
    updateSagaParticipantsCategory(),
    createSagaParticipantsCategory(),
    getSagaParticipantTypes(),
    getSagaProductAccessibilityList(),
    addSagaProductAccessibility(),
    getSagaProductAccessibility(),
    resetSagaProductAccessibility(),
    addSagaAccessibilityProduct(),
    sagaAccessibilityProductsAdd(),
    sagaAccessibilityProductsDelete(),
    deleteSagaProductAccessibility(),
    updateSagaProductAccessibility(),
    deleteSagaAccessibilityProducts(),
    getSagaPermissionsList(),
    getSagaPermission(),
    resetSagaPermission(),
    createSagaPermission(),
    editSagaPermission(),
    deleteSagaPermission(),
    getSagaSubscriptionsList(),
    getSagaSubscription(),
    resetSagaSubscription(),
    createSagaSubscription(),
    editSagaSubscription(),
    deleteSagaSubscription(),
    addSagaExtra(),
    addSagaExtraProduct(),
    addSagaExtrasProduct(),
    deleteSagaExtrasProduct(),
    deleteSagaExtra(),
    deleteSagaExtraProducts(),
    getSagaExtra(),
    getSagaExtraList(),
    getSagaExtraProducts(),
    getSagaProductExtra(),
    resetSagaExtra(),
    updateSagaExtra(),
    getSagaCustomQuestion(),
    getSagaCustomQuestionList(),
    resetSagaCustomQuestion(),
    addSagaCustomQuestion(),
    updateSagaCustomQuestion(),
    deleteSagaCustomQuestion(),
    addSagaCustomQuestionProduct(),
    addSagaCustomQuestionsProduct(),
    deleteSagaCustomQuestionsProduct(),
    deleteSagaCustomQuestionProducts(),
    getListSagaProductPricing(),
    updateSagaProductPricing(),
    deleteSagaProductPricing(),
    getSagaHealthSafetyRestriction(),
    addSagaHealthSafetyRestriction(),
    getSagaHealthSafetyRestrictionsList(),
    deleteSagaHealthSafetyRestriction(),
    addSagaHealthSafetyRestrictionProduct(),
    addSagaProductHealthSafetyRestrictions(),
    deleteSagaProductHealthSafetyRestrictions(),
    editSagaHealthSafetyRestriction(),
    deleteSagaHealthSafetyRestrictionProducts(),
    getSagaAnalyticsHighlights(),
    resetSagaAnalyticsHighlights(),
    addSagaReport(),
    addSagaReportTemplate(),
    getSagaReportsTemplatesList(),
    getSagaReportTemplateId(),
    updateSagaReportTemplate(),
    deleteSagaReportTemplate(),
    addSagaExtraTaxes(),
    deleteSagaExtraTaxes(),
    getSagaMarketingList(),
    getSagaMarketing(),
    addSagaMarketing(),
    updateSagaMarketing(),
    deleteSagaMarketing(),
    watchCabanasMapping(),
    updateSagaPassword(),
    getSagaCabanaCategoriesList(),
    addSagaCabanaCategory(),
    resetCabanaCategoryAdd(),
    resetListCabanaCategoryList(),
    getCabanasCategory(),
    editCabanasCategory(),
    deleteSagaCabanaCategory(),
    addInclusionsExclusionsAccessibility(),
    getSagaCabanaList(),
    getDestinationsSgwSaga(),
    getDestinationsSgwDetailSaga(),
    getDestinationsSaga(),
    deleteDestinationSaga(),
    addDestinationSaga(),
    updateDestinationSaga(),
    getNavigationList(),
    getNavigation(),
    addNavigation(),
    editNavigation(),
    editNavigationList(),
    deleteNavegationSaga(),
    getSagaCabanasUnmappedCount(),
    getSagaAccountPropertiesList(),
    getAccountProperties(),
    addAccountProperties(),
    editAccountProperties(),
    editAccountPropertiesList(),
    deleteAccountPropertiesSaga(),
    importAccountProperties(),
    importAccountPropertiesImages(),
    resumeImportImagesJob(),
  ]);
}
